// Generated by Melange

import * as Buhta_cabinet__Button from "../html/Button.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";
import PlusSvg from "static/icons/plus.svg";

function make(className) {
  return function (onClick) {
    return function (children) {
      let tmp = {
        size: "s",
        onClick: onClick,
        children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(PlusSvg, {}),
                JsxRuntime.jsx("div", {
                      children: children,
                      className: "ml-2"
                    })
              ],
              className: "btn-content flex items-center"
            })
      };
      if (className !== undefined) {
        tmp.className = Caml_option.valFromOption(className);
      }
      return JsxRuntime.jsx(Buhta_cabinet__Button.make, tmp);
    };
  };
}

function AddItemButton(Props) {
  return Curry._1(make(Props.className)(Props.onClick), Props.children);
}

const make$1 = AddItemButton;

export {
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
